import { DependencyContainer } from '../../DependencyContainer';
import { AuthError, User } from './types';
import { Routes } from '../../config';

export default class LoginService {
  constructor(private readonly factory: DependencyContainer) {}
  private readonly localStorageAuthErrorPropName = 'authError';
  private readonly localStorageTargetRoutePropName = 'targetRoute';
  private readonly localStorageOktaToken = 'okta-token-storage';

  getAuthError(): AuthError | undefined {
    const authErrorLS = localStorage.getItem(
      this.localStorageAuthErrorPropName,
    );
    if (!authErrorLS) {
      return undefined;
    }
    const authError = JSON.parse(authErrorLS);
    return authError;
  }

  setAuthError(error: AuthError): void {
    localStorage.setItem(
      this.localStorageAuthErrorPropName,
      JSON.stringify(error),
    );
  }

  removeAuthError(): void {
    localStorage.removeItem(this.localStorageAuthErrorPropName);
  }

  setTargetRoute(targetRoute: Routes): void {
    localStorage.setItem(this.localStorageTargetRoutePropName, targetRoute);
  }

  getTargetRoute(): Routes {
    const targetRoute = localStorage.getItem(
      this.localStorageTargetRoutePropName,
    );
    return (targetRoute as Routes) || Routes.Index;
  }

  getUser(): User {
    const json = localStorage.getItem(this.localStorageOktaToken) || '{}';
    const oktaToken = JSON.parse(json);
    const claims = oktaToken?.idToken?.claims ?? {};
    return {
      id: claims.cid ?? '',
      email: claims.email ?? '',
      firstName: claims.firstName ?? '',
      lastName: claims.lastName ?? '',
      idToken: oktaToken?.idToken?.idToken ?? '',
      expiresAt: oktaToken?.idToken?.expiresAt ?? 0,
    };
  }

  removeTargetRoute(): void {
    localStorage.removeItem(this.localStorageTargetRoutePropName);
  }
}
